import request from '@/utils/request'
import qs from 'qs'

export function getHome(data) {
    data = qs.stringify(data)
    return request({
        url: '/dynamics/getHome',
        method: 'post',
        data
    })
}

export function getDynamicsList(data) {
    data = qs.stringify(data)
    return request({
        url: '/dynamics/getDynamicsList',
        method: 'post',
        data
    })
}

export function findMembers(data) {
    data = qs.stringify(data)
    return request({
        url: '/share/findMembers',
        method: 'post',
        data
    })
}

export function applyMembers(data) {
    data = qs.stringify(data)
    return request({
        url: '/share/applyMembers',
        method: 'post',
        data
    })
}

export function agreeApply(data) {
    data = qs.stringify(data)
    return request({
        url: '/share/agreeApply',
        method: 'post',
        data
    })
}

export function getFriendList(data) {
    data = qs.stringify(data)
    return request({
        url: '/share/getFriendList',
        method: 'post',
        data
    })
}

export function getApplyList(data) {
    data = qs.stringify(data)
    return request({
        url: '/share/getApplyList',
        method: 'post',
        data
    })
}

export function getFriendsRank(data) {
    data = qs.stringify(data)
    return request({
        url: '/share/getFriendsRank',
        method: 'post',
        data
    })
}

export function deleteApplyList(data) {
    data = qs.stringify(data)
    return request({
        url: '/share/deleteApplyList',
        method: 'post',
        data
    })
}


export function refuseApply(data) {
    data = qs.stringify(data)
    return request({
        url: '/share/refuseApply',
        method: 'post',
        data
    })
}

export function getFriendsDetail(data) {
    data = qs.stringify(data)
    return request({
        url: '/share/getFriendsDetailNew',
        method: 'post',
        data
    })
}

export function friendBodyStatus(data) {
    data = qs.stringify(data)
    return request({
        url: '/share/friendBodyStatus',
        method: 'post',
        data
    })
}

export function friendForecast(data) {
    data = qs.stringify(data)
    return request({
        url: '/share/friendForecast',
        method: 'post',
        data
    })
}

export function friendInformation(data) {
    data = qs.stringify(data)
    return request({
        url: '/share/friendInformation',
        method: 'post',
        data
    })
}

export function deleteMembers(data) {
    data = qs.stringify(data)
    return request({
        url: '/share/deleteMembers',
        method: 'post',
        data
    })
}

export function updateAuthority(data) {
    data = qs.stringify(data)
    return request({
        url: '/share/updateAuthority',
        method: 'post',
        data
    })
}

export function selectAuthority(data) {
    data = qs.stringify(data)
    return request({
        url: '/share/selectAuthority',
        method: 'post',
        data
    })
}

export function discoverMembers(data) {
    data = qs.stringify(data)
    return request({
        url: '/share/discoverMembers',
        method: 'post',
        data
    })
}

export function getCity(data) {
    data = qs.stringify(data)
    return request({
        url: '/weather/getCity',
        method: 'post',
        data
    })
}

export function comment(data) {
    data = qs.stringify(data)
    return request({
        url: '/dynamics/comment',
        method: 'post',
        data
    })
}

export function like(data) {
    data = qs.stringify(data)
    return request({
        url: '/dynamics/like',
        method: 'post',
        data
    })
}

export function getUnread(data) {
    data = qs.stringify(data)
    return request({
        url: '/dynamics/getUnread',
        method: 'post',
        data
    })
}

export function clearMsg(data) {
    data = qs.stringify(data)
    return request({
        url: '/dynamics/clearMsg',
        method: 'post',
        data
    })
}

export function getDynamicsInfo(data) {
    data = qs.stringify(data)
    return request({
        url: '/dynamics/getDynamicsInfo',
        method: 'post',
        data
    })
}

export function getFriendsRecord(data) {
    data = qs.stringify(data)
    return request({
        url: '/share/getFriendsRecord',
        method: 'post',
        data
    })
}



// WEBPACK FOOTER //
// ./src/api/share.js